import React, { Fragment } from 'react'
import Header from './Header'
import Logo from './Logo'

const InternalErrorView = (props) => {
    return (
        <Fragment>
            <div className='notfound-content'>
                <Header logo={<Logo src={props.themeConfig.logoPath} />} />
                <div className='content'>
                    <p className='notfound-content-title uppercase'>{props.message}</p>
                    <p className='code'>{props.code}</p>
                </div>
            </div>
        </Fragment>
    )
}

export default InternalErrorView